// extracted by mini-css-extract-plugin
module.exports = {"tabs":"galleryPageTabsButtons_tabs__MEUj7","tabSelected":"galleryPageTabsButtons_tabSelected__1-U2w","tab":"galleryPageTabsButtons_tab__1xJ4p"};
    if(module.hot) {
      // 1790670308778
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  